import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { makeMarketDataCandleLastPriceParamsBySymbolSelector } from '../liteTradeSelectors';
import { ILiteTradeAssetSymbol } from '../types/liteTradeReducer.t';

function useMarketDataCandleLastPriceParamsBySymbol(symbol: ILiteTradeAssetSymbol) {
    const getMarketDataCandleLastPriceParamsBySymbolSelector = useMemo(
        () => makeMarketDataCandleLastPriceParamsBySymbolSelector(symbol),
        [symbol]
    );

    return useSelector(getMarketDataCandleLastPriceParamsBySymbolSelector);
}

export default useMarketDataCandleLastPriceParamsBySymbol;
